import { PlatformLocation } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSpinnerService } from 'ngx-spinner';
import { Cliente } from 'src/app/models/cliente';
import { CRMAtividade } from 'src/app/models/crm/crmatividade';
import { CRMTipoAtividade } from 'src/app/models/crm/crmtipo-atividade';
import { CRMPesoAtividade, StatusCadastroEnum } from 'src/app/models/enum';
import { EnumeracaoBO } from 'src/app/models/enumeracao';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ClienteService } from 'src/app/services/cliente.service';
import { CrmatividadeService } from 'src/app/services/crm/crmatividade.service';
import { CrmenumService } from 'src/app/services/crm/crmenum.service';
import { CrmtipoAtividadeService } from 'src/app/services/crm/crmtipo-atividade.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import swal from 'sweetalert2';
import { PremissasService } from "../../../services/premissas.service";
import { PremissasSistema } from "../../../models/premissas-sistema";

declare const $: any;

@Component({
  selector: 'app-cadastrar-atividade',
  templateUrl: './cadastrar-atividade.component.html',
  styleUrls: ['./cadastrar-atividade.component.scss']
})
export class CadastrarAtividadeComponent implements OnInit {
  atividade: CRMAtividade;
  idOportunidade: number;
  tiposDeAtividade: CRMTipoAtividade[] = [];
  horaInicio = '';
  horaFim = '';
  responsaveis = [];
  editando: boolean = false;
  atividadeDuracoes: EnumeracaoBO[] = [];

  summerNoteConfig: any = {
    lang: 'pt-BR',
    toolbar: [
      ['style', ['bold', 'italic', 'underline', 'clear']],
      ['fontsize', ['fontsize']],
      ['para', ['ul', 'ol']],
      ['paragraph'],
      ['code', ['codeview']],
    ],
    height: '100px',
    placeholder: 'Anotações...',
  };

  premissasSistema: PremissasSistema = new PremissasSistema();

  public config: PerfectScrollbarConfigInterface = {};

  constructor(
    public dialogRef: MatDialogRef<CadastrarAtividadeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService,
    private atividadeService: CrmatividadeService,
    private tipoAtividadeService: CrmtipoAtividadeService,
    private enumService: CrmenumService,
    private carregandoService: CarregandoService,
    public dialog: MatDialog,
    private router: Router,
    private platformLocation: PlatformLocation,
    public crmEnumService: CrmenumService,
    private premissasService: PremissasService
  ) { }

  ngOnInit() {
    this.buscarPremissasSistema();
    this.buscarDuracoes();
    this.buscarTiposDeAtividade();

    this.atividade = this.data.atividade;

    if (this.atividade.id) {
      const dTempIni = new Date(this.atividade.dataHora);
      const dTempFim = new Date(this.atividade.dataHoraFim);
      this.horaInicio = dTempIni.getHours().toString().padStart(2, '0') + ':' + dTempIni.getMinutes().toString().padStart(2, '0');
      this.horaFim = dTempFim.getHours().toString().padStart(2, '0') + ':' + dTempFim.getMinutes().toString().padStart(2, '0');
      this.editando = true;
    }
    this.idOportunidade = this.data.idOportunidade;
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra('buscarPremissasSistema');
    this.premissasService.consultarPremissasSistema().subscribe(
      (premissas) => {
        this.premissasSistema = premissas;

        this.carregandoService.esconde('buscarPremissasSistema');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPremissasSistema');
        this.notificacaoService.erro(erro);
      }
    );
  }

  salvar() {
    this.carregandoService.mostra('salvaAtividade');

    this.atividade.idOportunidade = this.idOportunidade;

    const dTempIni = new Date(this.atividade.dataHora);
    const dTempFim = new Date(this.atividade.dataHoraFim);

    dTempIni.setHours(Number(this.horaInicio.split(':')[0]));
    dTempIni.setMinutes(Number(this.horaInicio.split(':')[1]) - dTempIni.getTimezoneOffset());

    dTempFim.setHours(Number(this.horaFim.split(':')[0]));
    dTempFim.setMinutes(Number(this.horaFim.split(':')[1]) - dTempFim.getTimezoneOffset());

    this.atividade.dataHora = dTempIni;
    this.atividade.dataHoraFim = dTempFim;

    if (
      !this.atividade.dataHoraFim ||
      !(this.atividade.dataHoraFim instanceof Date) ||
      isNaN(this.atividade.dataHoraFim.getTime())
    ) {
      this.atividade.dataHoraFim = null;
    }

    if (!this.atividade.tipoAtividade.vincularOrcamento) {
      this.atividade.idOrcamento = null;
    }

    if (!this.responsaveis || this.responsaveis.length === 0) {
      this.atividade.idUsuario = 0;
    } else {
      this.atividade.idUsuario = Number(this.atividade.idUsuario);
    }

    this.atividadeService.salvar(this.atividade).subscribe((resp) => {
      this.notificacaoService.sucesso('Atividade salva com sucesso!!!');
      this.carregandoService.esconde('salvaAtividade');
      this.dialogRef.close(this.atividade);

    }, (erro) => {
      this.carregandoService.esconde('salvaAtividade');
      this.notificacaoService.erro(erro);
    });
  }

  buscarDuracoes() {
    this.carregandoService.mostra('buscarDuracoes');

    this.crmEnumService.consultarDuracoesDaAtividade().subscribe(
      (itens) => {
        this.atividadeDuracoes = itens;

        if (!this.atividadeDuracoes.some((e) => e.valor === this.atividade.duracao)) {
          this.atividade.duracao = undefined;
        }

        this.carregandoService.esconde('buscarDuracoes');
      },
      (erro) => {
        this.carregandoService.esconde('buscarDuracoes');
        this.notificacaoService.erro(erro);
      }
    );
  }

  fechar() {
    this.dialogRef.close();
  }

  buscarTiposDeAtividade() {
    this.carregandoService.mostra('buscaTiposDeAtividade');

    this.tipoAtividadeService.consultarTiposAtividade().subscribe(tipos => {
      this.tiposDeAtividade = tipos.map(t => t.statusCadastro === StatusCadastroEnum.Ativo ? t : { ...t, disabled: true });
      this.selecionaTipoAtividade();
      this.carregandoService.esconde('buscaTiposDeAtividade');
    }, (erro) => {
      this.carregandoService.esconde('buscaTiposDeAtividade');
      this.notificacaoService.erro(erro);
    });
  }

  buscarResponsaveisDoTipo() {
    if (!this.atividade.idTipoAtividade) {
      this.atividade.idUsuario = undefined;
      this.responsaveis = [];
      return;
    }

    this.carregandoService.mostra('buscarResponsaveisDoTipo');

    this.tipoAtividadeService.consultarPorIdTipoAtividade(this.atividade.idTipoAtividade).subscribe((tipo: CRMTipoAtividade) => {
      this.responsaveis = tipo.responsaveis.map(p => ({ id: Number(p.idFuncion), nome: p.nome }));

      if (this.atividade.idUsuario !== undefined && this.atividade.idUsuario !== null
        && !this.responsaveis.some(p => Number(p.id) === Number(this.atividade.idUsuario))) {
        this.atividade.idUsuario = undefined;
      }

      this.carregandoService.esconde('buscarResponsaveisDoTipo');
    }, (erro) => {
      this.carregandoService.esconde('buscarResponsaveisDoTipo');
      this.notificacaoService.erro(erro);
    });
  }

  cadastrarNovoOrcamento() {
    const url = this.router.createUrlTree(['/orcamentos/novo']);

    window.open(location.origin + this.platformLocation.getBaseHrefFromDOM() + url.toString(), '_blank');
  }

  visualizarOrcamento() {
    const url = this.router.createUrlTree(['/orcamentos/editar', this.atividade.idOrcamento]);

    window.open(location.origin + this.platformLocation.getBaseHrefFromDOM() + url.toString(), '_blank');
  }

  selecionaTipoAtividade() {
    if (this.atividade.idTipoAtividade && !this.atividade.tipoAtividade) {
      this.atividade.tipoAtividade = this.tiposDeAtividade.find(p => p.id === this.atividade.idTipoAtividade);
    }
    this.buscarResponsaveisDoTipo();
  }

  validaSalvar() {
    if (!this.atividade.tipoAtividade) {
      return false;
    }

    if (!this.atividade.tipoAtividade.vincularOrcamento) {
      return true;
    } else {
      return this.atividade.idOrcamento;
    }
  }

  finalizarAtividade(tipoConclusao: CRMPesoAtividade) {
    this.atividade.peso = tipoConclusao;

    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente finalizar a Atividade?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.atividade.status = 1;

        this.carregandoService.mostra('salvaAtividade');
        this.atividadeService.alterarStatus(this.atividade).subscribe(resp => {

          this.notificacaoService.sucesso('Atividade salva com sucesso!!!');
          this.carregandoService.esconde('salvaAtividade');
          this.fechar();

        }, (erro) => {
          this.carregandoService.esconde('salvaAtividade');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }
}
